module.exports = __webpack_public_path__ + "static/img/company-10.d378f3bc.png";